import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select"
import * as moment from "moment"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { getAllEmployees as onGetAllEmployees } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast, validateEmail } from "helpers/function_helper"


const AddNewEmployee = props => {

  const salaryTypeOptions = [
    {
      label: "Daily",
      value: "daily"
    },{
      label: "Monthly",
      value: "monthly"
    },{
      label: "Yearly",
      value: "yearly"
    }
  ]

  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    employeeName: null,
  })
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [employeeName, setEmployeeName] = useState('')
  const [employeeAddress, setEmployeeAddress] = useState('')
  const [employeeMobile, setEmployeeMobile] = useState('')
  const [employeePhone, setEmployeePhone] = useState('')
  const [employeeFax, setEmployeeFax] = useState('')
  const [employeeEmail, setEmployeeEmail] = useState('')
  const [employeeDoj, setEmployeeDoj] = useState(moment(new Date()).format("yyyy-MM-DD"))
  const [employeeDojTemp, setEmployeeDojTemp] = useState(new Date())
  const [employeeSalary, setEmployeeSalary] = useState('0')
  const [employeeSalaryMasked, setEmployeeSalaryMasked] = useState('0')
  const [openingBalance, setOpeningBalance] = useState('0')
  const [employeeSalaryType, setEmployeeSalaryType] = useState(salaryTypeOptions[0])
  const [employeeWorkingHours, setEmployeeWorkingHours] = useState('10')

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inp-emp-name').focus();
      document.getElementById('inp-emp-name').select();
    }, 250);
    if(props.enteredText != ''){
      setEmployeeName(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      setEmployeeName(props.detailsForEdit.name)
      setEmployeeAddress(props.detailsForEdit.address)
      setEmployeeMobile(props.detailsForEdit.mobile)
      setEmployeePhone(props.detailsForEdit.phone)
      setEmployeeFax(props.detailsForEdit.fax)
      setEmployeeEmail(props.detailsForEdit.email)
      if(props.detailsForEdit.doj && props.detailsForEdit.doj != ''){
        setEmployeeDoj(props.detailsForEdit.doj)
        setEmployeeDojTemp(new Date(props.detailsForEdit.doj))
      }
      setEmployeeSalary(props.detailsForEdit.salary)
      setEmployeeSalaryMasked('XXXXX')
      if(props.detailsForEdit.salarytype && props.detailsForEdit.salarytype != ''){
        const salType = salaryTypeOptions.filter(each => each.value == props.detailsForEdit.salarytype)
        if(salType && salType.length == 0){
          setEmployeeSalaryType(salType[0])
        }
      }
      setEmployeeWorkingHours(props.detailsForEdit.workinghours)
      setOpeningBalance(props.detailsForEdit.openingBalance)
    }
  }, [props.detailsForEdit])

  

  /*
  const { response, error, addInProgress } = useSelector(state => ({
    response: state.Products.response,
    error: state.Products.error,
    addInProgress: state.Products.addInProgress
  }))

  useEffect(() => {
    if(response && response.status && response.status == 'success'){
      dispatch(onGetAllEmployees())
      props.newlyAddedValue(response.confirmation_code)
    }
  }, [error,response,addInProgress])
  */

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }
  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(employeeName && employeeName != ""){
      modifiedV["employeeName"] = true
    }
    else{
      modifiedV["employeeName"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()
    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'name': employeeName,
        'address' : employeeAddress,
        'mobile' : employeeMobile,
        'phone' : employeePhone,
        'fax' : employeeFax,
        'email' : employeeEmail,
        'doj' : employeeDoj,
        'salary' : employeeSalary,
        'salarytype' : employeeSalaryType.value,
        'workinghours' : employeeWorkingHours,
        'openingBalance' : openingBalance,
      }, 'Employee')

      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllEmployees())
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'name': employeeName,
          'address' : employeeAddress,
          'mobile' : employeeMobile,
          'phone' : employeePhone,
          'fax' : employeeFax,
          'email' : employeeEmail,
          'doj' : employeeDoj,
          'salary' : employeeSalary,
          'salarytype' : employeeSalaryType.value,
          'workinghours' : employeeWorkingHours,
          'openingBalance' : openingBalance,
        }, 'Employee')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllEmployees())
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="">
        <Container fluid={true} className="min-height-700">
          <Row>
            <Col lg="12">
              <Card  style={{paddingBottom: (window.screen.height/2) +"px"}}>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inp-emp-name">
                              Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inp-emp-name"
                              maxLength="150"
                              value={employeeName}
                              onChange={event => {
                                onChangeValidation("employeeName", event.target.value.trim())
                                setEmployeeName(event.target.value)
                              }}
                              invalid={
                                validation["employeeName"] !== true &&
                                validation["employeeName"] !== null
                              }
                            />
                            {(validation["employeeName"] === false) &&
                              <div className="custom-error">
                                Please enter the Employee Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              Address
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpname"
                              maxLength="200"
                              value={employeeAddress}
                              onChange={event => {
                                onChangeValidation("employeeAddress", event.target.value.trim())
                                setEmployeeAddress(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpmobile">
                              Mobile
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpmobile"
                              maxLength="15"
                              value={employeeMobile}
                              onChange={event => {
                                onChangeValidation("employeeMobile", event.target.value.trim())
                                setEmployeeMobile(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpdoj">
                              PayRoll Start Date
                            </Label>
                            <div className="d-flex">
                            <DatePicker
                              maxDate={new Date()}
                              selected={employeeDojTemp}
                              className="form-control"
                              isClearable
                              onChange={date => {
                                setEmployeeDojTemp(date)
                                if(date){
                                  const date1 = moment(new Date(date)).format("yyyy-MM-DD")
                                  setEmployeeDoj(date1)
                                }
                              }}
                              dateFormat="dd/MMM/yyyy"
                            />
                            {(validation["employeeDoj"] === false) &&
                              <div className="custom-error">
                                Please enter a valid Date
                              </div>
                            }
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpsalary">
                              Salary
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpsalary"
                              maxLength="10"
                              value={employeeSalaryMasked}
                              onChange={event => {
                                onChangeValidation("employeeSalary", event.target.value.trim())
                                if(isNumber(event.target.value.trim())){
                                  setEmployeeSalary(event.target.value)
                                  setEmployeeSalaryMasked(event.target.value)
                                }
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpsalarytype">
                              Salary Type
                            </Label>
                            <Select
                              onChange={(e) => {
                                //console.log('pdt type:'+JSON.stringify(e))
                                setEmployeeSalaryType(e)
                              }}
                              value={employeeSalaryType}
                              options={salaryTypeOptions}
                              classNamePrefix="select2-selection"
                              isLoading={false}
                              id="inpsalarytype"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpworkinghours">
                              Working hours / day
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpsalary"
                              maxLength="4"
                              value={employeeWorkingHours}
                              onChange={event => {
                                onChangeValidation("employeeWorkingHours", event.target.value.trim())
                                if(isNumber(event.target.value.trim())){
                                  setEmployeeWorkingHours(event.target.value)
                                }
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="openingbalance">
                              Opening Balance
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="openingbalance"
                              maxLength="10"
                              value={openingBalance}
                              onChange={event => {
                                onChangeValidation("openingBalance", event.target.value.trim())
                                if(isNumber(event.target.value.trim())){
                                  setOpeningBalance(event.target.value)
                                }
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-5">
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewEmployee.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewEmployee
